import { CheckUserAuthTokenResponseDto } from "@/data/dto/check-user-auth-token-response-dto";
import { TimeZoneCheckResponseDto } from "@/data/dto/time-zone-check-dto";
import { CheckUserAuthTokenRequestPayload } from "@/data/payload/check-user-auth-token-request-payload";
import { AuthSource } from "@/data/source/auth-source";
import { UserPasswordManageSource } from "@/data/source/user-password-reset-source";
import { AuthRepository } from "@/domain/repository/auth-repository";
import { SATError, SATResult } from "@sadtx/sat-error";
import { TimeZoneCheckReponseInfoMapper } from "../mapper/time-zone-check-reponse-info-mapper";
import { safeMapToEntity } from "./safe-map-to-entity";

export class AuthRepositoryImpl implements AuthRepository {
  //MARK:- Constructor
  constructor(
    private readonly authSource: AuthSource,
    private readonly userPasswordManageSource: UserPasswordManageSource
  ) {}

  //MARK:- Interface
  async userTokenCheck(): Promise<SATResult<void, SATError>> {
    const result = await this.authSource.userTokenCheck();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  // async issueVerificationCode(
  //   payload: IssueUserCodeRequestPayload
  // ): Promise<SATResult<IssueVerificationCodeResponseDto, SATError>> {
  //   const result = await this.phoneAuthSource.issueUserAuthCode(payload);
  //   if (result.isFailure) {
  //     return SATResult.failure(result.error);
  //   }
  //   return SATResult.success(result.value!);
  // }

  async checkUserAuthToken(
    payload: CheckUserAuthTokenRequestPayload
  ): Promise<SATResult<CheckUserAuthTokenResponseDto, SATError>> {
    const result = await this.userPasswordManageSource.validUserAuthCode(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(result.value!);
  }

  async exchangeSecretKeyByToken(token: string): Promise<SATResult<void, SATError>> {
    const result = await this.authSource.exchangeSecretKeyByToken(token);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async exchangeAndSaveAESecretKeyByCookie(): Promise<SATResult<void, SATError>> {
    const result = await this.authSource.exchangeSecretKeyByCookie();

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async checkTimeZone(): Promise<SATResult<TimeZoneCheckResponseDto, SATError>> {
    const result = await this.authSource.checkTimeZone();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return safeMapToEntity(
      result.value,
      TimeZoneCheckReponseInfoMapper.toEntity,
      "AuthRepositoryImpl::checkTimeZone"
    );
  }
}
